/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PaymentRoundCreditCardPayment {
  boxId?: string;
  creditCardPaymentId?: number;
  dateAuthorized?: Date;
  dateCreated?: Date;
  email?: string;
  extraData?: string;
  gatewayId?: number;
  gatewayName?: string;
  lr?: string;
  paymentResponseMessageType?: string;
  paymentResponseMessageTypeId?: number;
  paymentRoundId?: number;
  subscriberId?: number;
  subscriberStatus?: string;
  subscriptionName?: string;
  tid?: string;
  transactionStatusName?: string;
}
